import { environment } from '@environments/environment';

import { isUntienotsIdValid } from './customer';
import { normalizeBaseHref } from './server';

/**
 * Fire-and-forget beacon POSTing an untienots_id to one of the server's
 * beacon endpoints (see `registerIdBeacon` in server.ts), so the event can
 * be monitored from the Cloud Run logs. Outside production it only logs to
 * the console. Browser-only: call sites must be `isPlatformBrowser`-guarded.
 */
export const sendIdBeacon = (
  path: string,
  logLabel: string,
  untienotsId: string
): void => {
  // Validate a lowercased copy: the shared validator only accepts lowercase
  // hex, but the beacon endpoints (and the URL extraction feeding `is-human`)
  // are case-insensitive, and beacons should fire for any real browser.
  if (!untienotsId || !isUntienotsIdValid(untienotsId.toLowerCase())) return;

  const baseHref = normalizeBaseHref(environment.baseHref);
  const endpoint = `${baseHref}${path}?untienots_id=${encodeURIComponent(untienotsId)}`;

  if (environment.production) {
    void fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ts: Date.now() }),
      keepalive: true,
    }).catch(() => undefined);
  } else {
    console.info(`[${logLabel}] untienots_id: ${untienotsId}`);
  }
};
